export var FixedPositionType;
(function (FixedPositionType) {
    FixedPositionType[FixedPositionType["TopLeft"] = 0] = "TopLeft";
    FixedPositionType[FixedPositionType["TopCenter"] = 1] = "TopCenter";
    FixedPositionType[FixedPositionType["TopRight"] = 2] = "TopRight";
    FixedPositionType[FixedPositionType["CenterLeft"] = 3] = "CenterLeft";
    FixedPositionType[FixedPositionType["CenterCenter"] = 4] = "CenterCenter";
    FixedPositionType[FixedPositionType["CenterRight"] = 5] = "CenterRight";
    FixedPositionType[FixedPositionType["BottomLeft"] = 6] = "BottomLeft";
    FixedPositionType[FixedPositionType["BottomCenter"] = 7] = "BottomCenter";
    FixedPositionType[FixedPositionType["BottomRight"] = 8] = "BottomRight";
})(FixedPositionType || (FixedPositionType = {}));
